import { format } from "date-fns";
import { toCurrency, toPercent } from "@helpers";

/**
 * Local midnight of the calendar date in a yyyy-MM-dd... string. The API
 * sends dates with the server's offset (2058-12-31T00:00:00+0100), which a
 * browser west of it would turn into the previous day, and month.
 */
export const parseCalendarDate = (iso: string) => {
  const [year, month, day] = iso.slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatMonthYear = (iso?: string) =>
  iso ? format(parseCalendarDate(iso), "MMM yyyy") : "";

export const formatAmount = (value = 0) =>
  toCurrency(value, "EUR", false, { maximumFractionDigits: 0 });

const sign = (value: number) => (value < 0 ? "−" : "+");

export const formatSignedAmount = (value = 0) =>
  `${sign(value)} ${formatAmount(Math.abs(value))}`;

export const formatSignedPercent = (fraction = 0) =>
  `${sign(fraction)}${toPercent(Math.abs(fraction), "auto", 1, 1)}`;

/** Calendar months from today's month to the end date's month */
export const monthsUntil = (endIso: string, todayIso: string) =>
  (Number(endIso.slice(0, 4)) - Number(todayIso.slice(0, 4))) * 12 +
  Number(endIso.slice(5, 7)) -
  Number(todayIso.slice(5, 7));
